export const NoInternetComponent = () => {
  return (
    <div className="flex items-center justify-center">
      <div className=" my-[12px] font-noto-sans text-[red]">No internet Connection</div>
    </div>
  )
}
